// extracted by mini-css-extract-plugin
export default {"variationFinishPage":"VariationFinishPage_variationFinishPage__4MF3q","container":"VariationFinishPage_container__S9PBX"};